// SafeHeir — service check-in branché Supabase (T-S5-02, résout K54/K55)
// Source unique : table checkin_config. Remplace le checkinService localStorage.
// Signatures identiques à l'ancien service : les call sites ne changent que l'import.
import { supabase } from './supabaseClient';
import { GRACE_DEFAULT } from '../config/checkinConfig';

async function currentUserId() {
  const { data: { user } } = await supabase.auth.getUser();
  return user?.id ?? null;
}

export const checkinService = {
  getConfig: async () => {
    try {
      const userId = await currentUserId();
      if (!userId) return { success: false, data: null };
      const { data, error } = await supabase
        .from('checkin_config').select('*').eq('user_id', userId).maybeSingle();
      if (error) { console.error('[SafeHeir] checkin getConfig:', error.message); return { success: false, data: null }; }
      return { success: true, data: data || null };
    } catch (error) {
      console.error('[SafeHeir] checkin getConfig:', error);
      return { success: false, data: null };
    }
  },

  saveConfig: async (configData) => {
    try {
      const userId = await currentUserId();
      if (!userId) return { success: false, error: 'Non authentifié' };
      const payload = {
        is_enabled:           configData.is_enabled           ?? false,
        frequency:            configData.frequency            ?? 'monthly',
        grace_period_days:    configData.grace_period_days    ?? GRACE_DEFAULT,
        custom_message:       configData.custom_message       ?? '',
        vacation_return_date: configData.vacation_return_date ?? null,
        updated_at:           new Date().toISOString(),
      };
      if ('next_check_in_due' in configData) {
        payload.next_check_in_due = configData.next_check_in_due;
      }
      const { data: updated, error: updErr } = await supabase
        .from('checkin_config').update(payload).eq('user_id', userId).select().maybeSingle();
      if (updErr) { console.error('[SafeHeir] checkin saveConfig update:', updErr.message); return { success: false, error: 'Erreur lors de la sauvegarde' }; }
      if (updated) return { success: true, data: updated };
      const { data: inserted, error: insErr } = await supabase
        .from('checkin_config')
        .insert({ user_id: userId, ...payload, last_check_in: null, next_check_in_due: null })
        .select().single();
      if (insErr) { console.error('[SafeHeir] checkin saveConfig insert:', insErr.message); return { success: false, error: 'Erreur lors de la sauvegarde' }; }
      return { success: true, data: inserted };
    } catch (error) {
      console.error('[SafeHeir] checkin saveConfig:', error);
      return { success: false, error: 'Erreur lors de la sauvegarde' };
    }
  },

  performCheckin: async (extendDays = 30, nextDate = null) => {
    try {
      const userId = await currentUserId();
      if (!userId) return { success: false, error: 'Non authentifié' };
      const nextCheckIn = (nextDate instanceof Date) ? nextDate : new Date(Date.now() + extendDays * 86400000);
      const now = new Date().toISOString();
      const next = nextCheckIn.toISOString();
      const { data: updated, error: updErr } = await supabase
        .from('checkin_config')
        .update({ last_check_in: now, next_check_in_due: next, updated_at: now, reminder_count: 0, last_reminder_at: null })
        .eq('user_id', userId).select().maybeSingle();
      if (updErr) { console.error('[SafeHeir] checkin performCheckin:', updErr.message); return { success: false, error: 'Erreur lors du check-in' }; }
      if (!updated) {
        const { error: insErr } = await supabase
          .from('checkin_config')
          .insert({ user_id: userId, is_enabled: false, frequency: 'monthly', grace_period_days: GRACE_DEFAULT, custom_message: '', last_check_in: now, next_check_in_due: next, updated_at: now, reminder_count: 0, last_reminder_at: null });
        if (insErr) { console.error('[SafeHeir] checkin performCheckin insert:', insErr.message); return { success: false, error: 'Erreur lors du check-in' }; }
      }
      return { success: true, next_checkin: nextCheckIn, message: `Check-in effectué. Prochain check-in le ${nextCheckIn.toLocaleDateString('fr-FR')}.` };
    } catch (error) {
      console.error('[SafeHeir] checkin performCheckin:', error);
      return { success: false, error: 'Erreur lors du check-in' };
    }
  },
};
